module.exports = __webpack_public_path__ + "static/media/Icon_menu_recommend_products_white.5725ea33.svg";